import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { authAPI } from '../services/(adminapi)/authAPI'
import './Signup.css'

const Signup = () => {
  const [formData, setFormData] = useState({
    businessName: '',
    email: '',
    password: '',
    confirmPassword: ''
  })
  const [errors, setErrors] = useState({})
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')

  const navigate = useNavigate()

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }))
    }
    if (error) {
      setError('')
    }
  }

  const validateForm = () => {
    const newErrors = {}
    if (!formData.businessName.trim()) {
      newErrors.businessName = 'Business name is required'
    }
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required'
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid'
    }
    if (!formData.password) {
      newErrors.password = 'Password is required'
    } else if (formData.password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters'
    }
    if (!formData.confirmPassword) {
      newErrors.confirmPassword = 'Please confirm your password'
    } else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match'
    }
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!validateForm()) {
      return
    }
    
    setIsLoading(true)
    setError('')
    
    try {
      // Only send required fields to backend (admin: true is added in authAPI)
      const { confirmPassword, ...signupData } = formData
      const response = await authAPI.signUp(signupData)
      
      // Store auth token
      if (response.data.token) {
        localStorage.setItem('adminAuthToken', response.data.token)
      }
      
      // Navigate to login page after successful signup
      navigate('/login')
    } catch (err) {
      const errorMessage = err.response?.data?.error || err.response?.data?.message || 'Sign up failed. Please try again.'
      setError(errorMessage)
      console.error('Sign up failed:', err)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="signup-container">
      <form className="signup-form" onSubmit={handleSubmit}>
        <h1 className="signup-title">Sign up</h1>
        
        {error && (
          <div className="signup-error">
            <span>{error}</span>
            <button 
              type="button"
              onClick={() => setError('')}
              className="clear-error-button"
            >
              ×
            </button>
          </div>
        )}

        <div className="signup-field-group">
          <label className="signup-label">Business Name</label>
          <input
            type="text"
            name="businessName"
            value={formData.businessName}
            onChange={handleChange}
            placeholder="business name"
            className={`signup-input ${errors.businessName ? 'signup-input-error' : ''}`}
          />
          {errors.businessName && <div className="signup-field-error">{errors.businessName}</div>}
        </div>

        <div className="signup-field-group">
          <label className="signup-label">Email Address</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="email address"
            className={`signup-input ${errors.email ? 'signup-input-error' : ''}`}
          />
          {errors.email && <div className="signup-field-error">{errors.email}</div>}
        </div>

        <div className="signup-field-group">
          <label className="signup-label">Password</label>
          <div className="signup-input-container">
            <input 
              type={showPassword ? "text" : "password"}
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="password"
              className={`signup-input ${errors.password ? 'signup-input-error' : ''}`}
            />
            <span 
              className="signup-eye-icon"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? '👁️' : '👁️‍🗨️'}
            </span>
          </div>
          {errors.password && <div className="signup-field-error">{errors.password}</div>}
        </div>

        <div className="signup-field-group">
          <label className="signup-label">Confirm Password</label>
          <div className="signup-input-container">
            <input
              type={showConfirmPassword ? "text" : "password"}
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="confirm password"
              className={`signup-input ${errors.confirmPassword ? 'signup-input-error' : ''}`}
            />
            <span 
              className="signup-eye-icon"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
              {showConfirmPassword ? '👁️' : '👁️‍🗨️'}
            </span>
          </div>
          {errors.confirmPassword && <div className="signup-field-error">{errors.confirmPassword}</div>}
        </div>

        <button
          type="submit"
          disabled={isLoading}
          className="signup-button"
        >
          {isLoading ? 'Creating Account...' : 'Sign up'}
        </button>

        <div className="signup-link-container">
          <p className="signup-link-text">
            Already have an account?{' '}
            <Link to="/login" className="signup-link">
              Sign in
            </Link>
          </p>
        </div>
      </form>
    </div>
  )
}

export default Signup









